$(function () {
    siteJs.init();
});
var siteJs = (function () {    
    const _headerFooter = function(){
    // ===== Header: Scroll-Zustand als Klassen-Toggle =====
      // Passiver Scroll-Listener (Hot-Path, nativ erlaubt); Zustand via Klasse, kein Style-Write.
      function onScroll() { $('.header').toggleClass('is-scrolled', window.scrollY > 50); }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();

      // ===== Mega-Menues (Desktop: hover, Mobile: click) =====
      var $navItems = $('.header__nav-item[data-mega]');
      function menuFor(key) { return $('.header__mega--' + key); }
      function closeAllMega() { $navItems.removeClass('is-open'); $('.header__mega').removeClass('is-open'); }
      $navItems.each(function () {
        var $item = $(this);
        var $menu = menuFor($item.attr('data-mega'));
        if (!$menu.length) { return; }
        function openMenu() {
          if (window.matchMedia('(hover: hover)').matches) {
            closeAllMega(); $item.addClass('is-open'); $menu.addClass('is-open');
          }
        }
        function closeSoon() {
          setTimeout(function () {
            if (!$menu[0].matches(':hover') && !$item[0].matches(':hover')) {
              $item.removeClass('is-open'); $menu.removeClass('is-open');
            }
          }, 100);
        }
        $item.on('mouseenter', openMenu).on('mouseleave', closeSoon);
        $menu.on('mouseenter', function () { $item.addClass('is-open'); $menu.addClass('is-open'); })
             .on('mouseleave', closeSoon);
        $item.find('a').first().on('click', function (e) {
          if (!window.matchMedia('(hover: hover)').matches) {
            e.preventDefault();
            var wasOpen = $item.hasClass('is-open');
            closeAllMega();
            if (!wasOpen) { $item.addClass('is-open'); $menu.addClass('is-open'); }
          }
        });
      });
      $(document).on('click', function (e) {
        var $t = $(e.target);
        if (!$t.closest('.header__nav-item[data-mega]').length && !$t.closest('.header__mega').length) { closeAllMega(); }
      });
      $(document).on('keydown', function (e) { if (e.key === 'Escape') { closeAllMega(); } });

      // ===== Hamburger / Mobile-Menue =====
      var $hamburger = $('.header__hamburger');
      var $mobile = $('.header__mobile-menu');
      if ($hamburger.length && $mobile.length) {
        $hamburger.on('click', function () {
          var willOpen = !$hamburger.hasClass('is-open');
          $hamburger.toggleClass('is-open', willOpen).attr('aria-expanded', willOpen ? 'true' : 'false');
          $mobile.toggleClass('is-open', willOpen).attr('aria-hidden', willOpen ? 'false' : 'true');
        });
        $mobile.find('a').on('click', function () {
          $hamburger.removeClass('is-open').attr('aria-expanded', 'false');
          $mobile.removeClass('is-open').attr('aria-hidden', 'true');
        });
      }

      // ===== Mobile-Akkordeon =====
      $('.header__mobile-menu-acc').on('click', function () {
        var $btn = $(this);
        var wasOpen = $btn.attr('aria-expanded') === 'true';
        $('.header__mobile-menu-acc').attr('aria-expanded', 'false');
          $btn.next().slideToggle();
        if (!wasOpen) { 
          $btn.attr('aria-expanded', 'true'); 
        }
      });

      // ===== Sprachumschalter (Drop-up) =====
      var $langSwitch = $('.footer__lang');
      var $langBtn = $('.footer__lang-btn');
      var $langCurrent = $('.footer__lang-current');
      if ($langSwitch.length && $langBtn.length) {
        function setLangOpen(o) {
          $langSwitch.toggleClass('is-open', o);
          $langBtn.attr('aria-expanded', o ? 'true' : 'false');
        }
        $langBtn.on('click', function (e) { e.stopPropagation(); setLangOpen(!$langSwitch.hasClass('is-open')); });
        $(document).on('click', function (e) { if (!$(e.target).closest('.footer__lang').length) { setLangOpen(false); } });
        $(document).on('keydown', function (e) { if (e.key === 'Escape') { setLangOpen(false); } });
      }

      // ===== Scroll-Reveal (Animation: nativ + IntersectionObserver) =====
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var $groups = $('[data-reveal]');
      if (!reduce && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) {
              // Stagger-Delay = Animation -> JS-Styling erlaubt
              $(en.target).find('.reveal').each(function (i) { this.style.transitionDelay = (i * 80) + 'ms'; });
              $(en.target).addClass('is-visible');
              io.unobserve(en.target);
            }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
        $groups.each(function () { io.observe(this); });
      } else {
        $groups.addClass('is-visible');
      }
  }
  const _footerSubscription = function(){
    $('#footerSubscriptionForm').on('submit', function (e) {
      e.preventDefault();
      if(!_footerSubscriptionLoading){
        _footerSubscriptionLoading = true;            
        $("#footerSubscriptionBtn").addClass("loading");
        e.preventDefault();
        dataObj = {};
        dataObj.email = $("#footerSubscriptionEmail").val();
        dataObj.language = $("#siteLang").val();
        $.ajax({
            url: "/ajax/subscription",
            type: "POST",
            data: dataObj,
            dataType: "json",
        })
            .done(function (d) {
                if (d.success) {                    
                  $('.footer__newsletter').attr('data-state', 'success');
                } else {
                  $.ambiance({
                    message: d.message,
                    type: 'error'
                  });
                }
            })
            .fail(function () {
              $.ambiance({
                message: 'An error occurred. Please try again later.',
                type: 'error'
              });
            })
            .always(function () {
              _footerSubscriptionLoading = false;            
              $("#footerSubscriptionBtn").removeClass("loading");
            });
      }
    });
  }
  const _reveal = function(){
    var $els = $('.gb-reveal');
    if (!('IntersectionObserver' in window)) { $els.addClass('is-visible'); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { $(e.target).addClass('is-visible'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    $els.each(function () { io.observe(this); });
  }

  const _getTextResources = function(){
    if($("#js-texts").length){
      return JSON.parse($("#js-texts").text());
    }
    return [];
  }

  const _progressBar = function(){
    if($('.gb-progress-bar').length){       
      var $progressFill = $('.gb-progress-bar-fill');
      function updateProgress() {
        var scrollTop = $(window).scrollTop();
        var docHeight = $(document).height() - $(window).height();
        var percent = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
        $progressFill.css('width', percent + '%');
      }
      $(window).on('scroll', updateProgress);
      updateProgress();
    }
  }
    return {
        init: function () {
            _headerFooter();
            _footerSubscription();
            _reveal();
            _progressBar();
            if($(".s-p15w__block").length>0){
                productOverviewJs.init();
            }
            if($("main[data-template=product]").length>0){
                productDetailJs.init();
            }
        }
    };
})();

var productOverviewJs = (function () {
    var _productTab = function () {
        $(".s-p15w__block__tab__it").on("click", function () {
        var index = $(this).index();
        $(this).siblings().removeClass("is-active");
        $(this).addClass("is-active");
        $(".s-p15w__block__tab-content__it").hide();
        $(".s-p15w__block__tab-content__it").eq(index).fadeIn();
        });
        $(".s-p15w__block__tab__btn").on("click", function () {
        var currentIndex = $(".s-p15w__block__tab__it.is-active").index();
        var index = $(this).is(".is-prev-btn") ? currentIndex - 1 : currentIndex + 1;
        if (index < 0) {
            index = $(".s-p15w__block__tab-content__it").length - 1;
        }
        if (index == $(".s-p15w__block__tab-content__it").length) {
            index = 0;
        }
        $(".s-p15w__block__tab__it").removeClass("is-active");
        $(".s-p15w__block__tab__it").eq(index).addClass("is-active");
        $(".s-p15w__block__tab-content__it").hide();
        $(".s-p15w__block__tab-content__it").eq(index).fadeIn();
        });
    }
    return {
        init: function () {
            _productTab();
        },
    };
})();

var productDetailJs = (function () {
  var _addRelatedProductToCartLoading = false,
      _removeRelatedProductFromCartLoading = false;
    var _updateCartBadge = function(count) {
        $(".header__icon-btn span").remove();
        $(".header__icon-btn").append("<span class='header__icon-btn-badge'>"+count+"</span>");
    }
    var _updateCartItem = function () {
        const originalFetch = window.fetch;

        window.fetch = async function () {

            const response = await originalFetch.apply(this, arguments);

            try {
                const url = arguments[0];

                if (typeof url === 'string' && url.includes('/cart/add')) {

                    // Wait until add-to-cart finished
                    const cart = await fetch('/cart.js').then(r => r.json());

                    _updateCartBadge(cart.item_count);
                    _displayPopup();
                }

            } catch (e) {
                console.error('Cart listener error:', e);
            }

            return response;
        };
    }
    var _displayPopup = function(){
      $.magnificPopup.open({
        items: {
          src: "#addedToCartPopup",
          type: "inline"
        },
        removalDelay: 500,
        callbacks: {
          beforeOpen: function () {
            this.st.mainClass = "mfp-fade added-to-cart-popup__mfp";
          }
        },
        midClick: true,
        fixedContentPos: false
      });
    }

    var _addRelatedProductToCart = function () {
      $(document).on(
        "click",
        ".added-to-cart-popup__product-it__add-btn",
        function () {
          var $self = $(this);
          var $product = $self.closest(".added-to-cart-popup__product-it");
          if (
            _addRelatedProductToCartLoading ||
            $product.hasClass("is-added")
          ) {
            return;
          }
          var variantId = $self.data("variant-id");
          // For products with variants, get the currently selected variant
          if (!variantId) {
            variantId = $product
              .find(".added-to-cart-popup__product-it__variants")
              .val();
          }
          if (!variantId) {
            return;
          }
          _addRelatedProductToCartLoading = true;
          $self.addClass("is-loading");
          var dataObj = {
            items: [
              {
                id: variantId,
                quantity: 1
              }
            ]
          };
          $.ajax({
            url: "/cart/add.js",
            type: "POST",
            data: dataObj,
            dataType: "json"
          })
          .done(function () {
            $product.addClass("is-added");
            $product
              .find(".added-to-cart-popup__product-it__variants")
              .prop("disabled", true);
          })
          .fail(function () {
            alert("Error occurred. Please try again later!");
          })
          .always(function () {
            _addRelatedProductToCartLoading = false;
            $self.removeClass("is-loading");
          });
        }
      );
    };
    var _removeRelatedProductFromCart = function () {
      $(document).on(
        "click",
        ".added-to-cart-popup__product-it__remove-btn",
        function () {
          var $self = $(this);
          var $product = $self.closest(".added-to-cart-popup__product-it");
          if (
            _removeRelatedProductFromCartLoading ||
            !$product.hasClass("is-added")
          ) {
            return;
          }
          var variantId = $self.data("variant-id");
          if (!variantId) {
            variantId = $product
              .find(".added-to-cart-popup__product-it__variants")
              .val();
          }
          if (!variantId) {
            return;
          }
          _removeRelatedProductFromCartLoading = true;
          $self.addClass("is-loading");
          var dataObj = {
            updates: {}
          };
          dataObj.updates[variantId] = 0;
          $.ajax({
            url: "/cart/update.js",
            type: "POST",
            data: dataObj,
            dataType: "json"
          })
          .done(function () {
            $product.removeClass("is-added");
            $product
              .find(".added-to-cart-popup__product-it__variants")
              .prop("disabled", false);
          })
          .fail(function () {
            alert("Error occurred. Please try again later!");
          })
          .always(function () {
            _removeRelatedProductFromCartLoading = false;
            $self.removeClass("is-loading");
          });
        }
      );
    };
    var _changeRelatedProductPrice = function () {
      $(document).on(
        "change",
        ".added-to-cart-popup__product-it__variants",
        function () {
          var $select = $(this);
          var $product = $select.closest(".added-to-cart-popup__product-it");
          var $option = $select.find("option:selected");
          var variantId = $option.val();
          var price = $option.data("price");
          var oldPrice = $option.data("o-price");
          // Update Add button's variant ID
          $product
            .find(".added-to-cart-popup__product-it__add-btn")
            .attr("data-variant-id", variantId)
            .data("variant-id", variantId);
          // Update Remove button's variant ID
          $product
            .find(".added-to-cart-popup__product-it__remove-btn")
            .attr("data-variant-id", variantId)
            .data("variant-id", variantId);
          // Update current price
          $product
            .find(".added-to-cart-popup__product-it__price--current span")
            .html(price);
          // Update old price
          var $oldPrice = $product
            .find(".added-to-cart-popup__product-it__price--old span");
          if (oldPrice) {
            $oldPrice.html(oldPrice);
          }
        }
      );
    };
    var _closePopup = function () {
      $(document).on(
        "click",
        ".added-to-cart-popup__continue-shopping-button",
        function (e) {
          e.preventDefault();
          $.magnificPopup.close();
        }
      );
    };
    return {
        init: function () {
            _updateCartItem();
            _addRelatedProductToCart();
            _removeRelatedProductFromCart();
            _changeRelatedProductPrice();
            _closePopup();
        },
    };
})();

